import { Injectable, signal } from '@angular/core';

/**
 * Tracks which tenant slug the user is currently scoped to.
 * Set on tenant-shell activation from /tenant/:slug/... routes.
 * Read by the http interceptor when it needs to attach a tenant token.
 */
@Injectable({ providedIn: 'root' })
export class TenantContext {
  readonly slug = signal<string | null>(null);

  set(slug: string | null): void {
    this.slug.set(slug);
  }

  current(): string | null {
    return this.slug();
  }

  /**
   * Best-effort slug extraction from a URL/path. Recognises both:
   *  - backend  : /v1/tenants/<slug>/...
   *  - frontend : /tenants/<slug>/...
   */
  static extractSlug(urlOrPath: string): string | null {
    const m =
      urlOrPath.match(/\/v1\/tenants\/([^/?#]+)/) ??
      urlOrPath.match(/\/tenants\/([^/?#]+)/);
    return m ? m[1] : null;
  }
}
